export type AppLoaded = boolean;

export const SET_APP_LOADED = 'SET_APP_LOADED';
